export const API_BASE = 'https://6uqbiwvsfh.execute-api.us-east-1.amazonaws.com/prod';
